/**
 *  @class
 *  @function FreeShipping
 *  Printbolt v364 — initial main-cart animation starts at 0 without flashing full first.
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const amountText = this.querySelector('.free-shipping--text span');
      const percentageBar = this.querySelector('.free-shipping--percentage');
      const total = parseInt(this.dataset.cartTotal, 10);
      const rawMinimum = parseInt(this.dataset.minimum, 10);
      const currencyRate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      const fixedMinimum = this.dataset.fixedMinimum === 'true';
      const minimum = fixedMinimum ? rawMinimum : Math.round(rawMinimum * currencyRate);

      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      let percentage = 1;

      if (Number.isFinite(total) && Number.isFinite(minimum) && minimum > 0 && total < minimum) {
        percentage = total / minimum;

        if (amountText && !fixedMinimum) {
          const remaining = minimum - total;
          const format = window.theme.settings.money_with_currency_format || '${{amount}}';
          amountText.innerHTML = formatMoney(remaining, format);
        }

        if (this.remainingText) this.remainingText.style.display = 'block';
        if (this.fullText) this.fullText.style.display = 'none';
      } else {
        if (this.remainingText) this.remainingText.style.display = 'none';
        if (this.fullText) this.fullText.style.display = 'block';
      }

      const targetPercentage = Math.max(0, Math.min(1, Number.isFinite(percentage) ? percentage : 0));
      const isMainCart = Boolean(this.closest('#Cart'));
      const shouldAnimateInitialMainCart =
        isMainCart &&
        percentageBar &&
        !window.__pbMainCartFreeShippingInitialAnimationDone;

      if (!shouldAnimateInitialMainCart) {
        this.style.setProperty('--percentage', targetPercentage);
        return;
      }

      /*
       * Important: keep the very first painted state at 0.
       * cart.js must NOT reset the bar after window.load, because that causes
       * the visible full → 0 → target flash that v363 produced.
       */
      window.__pbMainCartFreeShippingInitialAnimationDone = true;
      percentageBar.style.transition = 'none';
      this.style.setProperty('--percentage', 0);

      // Force the browser to commit scale(0) before restoring the theme transition.
      void percentageBar.offsetWidth;

      window.requestAnimationFrame(() => {
        percentageBar.style.removeProperty('transition');

        window.requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.style.setProperty('--percentage', targetPercentage);
        });
      });
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
